import { Link } from "react-router-dom";
import { homeCategories } from "@/mocks/categories";

const colorMap: Record<string, string> = {
  primary: "bg-primary-50 text-primary-600 border-primary-100 group-hover:bg-primary-500 group-hover:text-background-50",
  accent: "bg-accent-50 text-accent-600 border-accent-100 group-hover:bg-accent-500 group-hover:text-primary-950",
  secondary:
    "bg-secondary-50 text-secondary-600 border-secondary-100 group-hover:bg-secondary-500 group-hover:text-background-50",
};

export default function CategoryGrid() {
  return (
    <section className="px-4 md:px-8 py-10">
      <div className="flex items-center gap-3 mb-6">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">分类快捷入口</h2>
        <span className="text-xs md:text-sm font-body text-foreground-500">按类型快速发现好作品</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {homeCategories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group flex flex-col items-center justify-center gap-3 py-5 md:py-6 rounded-lg border border-background-200 bg-background-50 hover:border-primary-200 transition-colors cursor-pointer"
          >
            <span
              className={`w-12 h-12 flex items-center justify-center rounded-full border transition-colors ${colorMap[cat.color]}`}
            >
              <i className={`${cat.icon} text-2xl`}></i>
            </span>
            <span className="text-sm font-label font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
              {cat.label}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}